<script lang="ts">
  import { cn } from '$lib/utils';
  import LogoIcon from '../LogoIcon.svelte';
</script>

<div class={cn('mr-4 flex items-center')}>
  <slot>
    <LogoIcon />
  </slot>
</div>
